import { ForgotPasswordForm } from '@/features/authentication/components/forgot-password-form'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forgot-password')({
  component: ForgotPasswordPage,
})

function ForgotPasswordPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50 dark:from-slate-900 dark:via-emerald-900/20 dark:to-teal-900/20 flex flex-col items-center justify-center p-4">
      <div className="relative z-10 w-full max-w-md">
        <ForgotPasswordForm />
        <div className="text-center mt-8 text-xs text-black dark:text-slate-400">
          <p>© 2025 UIBFS. All rights reserved.</p>
        </div>
      </div>
    </div>
  )
}
